import React from 'react';
import { CardsContainer } from './CardsWrapper.styles';
import FragmentedCategories from './Cards/FragmentedCategories';
import WellManagedCategories from './Cards/WellManagedCategories';
import SignificantYoyGrowth from './Cards/SignificantYoyGrowth';
import CommonVendors from './Cards/CommonVendors';
import OutofPolicySpend from './Cards/OutofPolicySpend';
import NonPreferedSuppliers from './Cards/NonPreferedSuppliers';
import IncreasedMonthlyPCard from './Cards/IncreasedMonthlyPCard';
import PaymentTerms from './Cards/PaymentTerms';
import CategorySpendAboveBenchmark from './Cards/CategorySpendAboveBenchmark';
import CategorySpendWithinBenchmark from './Cards/CategorySpendWithinBenchmark';
import CategoryRevenueAboveBenchmark from './Cards/CategoryRevenueAboveBenchmark';
import CategoryRevenueWithinBenchmark from './Cards/CategoryRevenueWithinBenchmark';
import SupplierSegmentation from './Cards/SupplierSegmentation';

const CardsWrapper = ({ cardsOption }) => {
	return (
		<CardsContainer>
			{cardsOption[0].isVisible && (
				<FragmentedCategories name={cardsOption[0].cardName} />
			)}
			{cardsOption[1].isVisible && (
				<WellManagedCategories name={cardsOption[1].cardName} />
			)}
			{cardsOption[2].isVisible && (
				<SignificantYoyGrowth name={cardsOption[2].cardName} />
			)}
			{cardsOption[3].isVisible && (
				<CommonVendors name={cardsOption[3].cardName} />
			)}
			{cardsOption[4].isVisible && (
				<OutofPolicySpend name={cardsOption[4].cardName} />
			)}
			{cardsOption[5].isVisible && (
				<NonPreferedSuppliers name={cardsOption[5].cardName} />
			)}
			{cardsOption[6].isVisible && (
				<IncreasedMonthlyPCard name={cardsOption[6].cardName} />
			)}
			{cardsOption[7].isVisible && (
				<PaymentTerms name={cardsOption[7].cardName} />
			)}
			{cardsOption[8].isVisible && (
				<CategorySpendAboveBenchmark name={cardsOption[8].cardName} />
			)}
			{cardsOption[9].isVisible && (
				<CategorySpendWithinBenchmark name={cardsOption[9].cardName} />
			)}
			{cardsOption[10].isVisible && (
				<CategoryRevenueAboveBenchmark name={cardsOption[10].cardName} />
			)}
			{cardsOption[11].isVisible && (
				<CategoryRevenueWithinBenchmark name={cardsOption[11].cardName} />
			)}
			{cardsOption[12].isVisible && (
				<SupplierSegmentation name={cardsOption[12].cardName} />
			)}
		</CardsContainer>
	);
};

export default CardsWrapper;
